import { useStoreGeoCountriesList, useStoreGeoStatesList } from "@motolynk/api-client";

/** Reference data changes rarely; the API also sends Cache-Control: max-age=3600. */
const HOUR = 60 * 60 * 1000;

/** Countries open for business (active), sorted by name. */
export function useCountries() {
  return useStoreGeoCountriesList({ query: { staleTime: HOUR, gcTime: HOUR } });
}

/** Active states/UTs of a country (ISO alpha-2, e.g. "IN"); idle until a country is chosen. */
export function useStates(country: string | undefined) {
  return useStoreGeoStatesList(
    { country: country ?? "" },
    { query: { enabled: Boolean(country), staleTime: HOUR, gcTime: HOUR } },
  );
}
